var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50151 1.03609C1.25743 0.792008 0.861706 0.792008 0.617629 1.03609C0.373551 1.28016 0.373551 1.67589 0.617629 1.91997L5.19786 6.5002L0.61765 11.0804C0.373573 11.3245 0.373572 11.7202 0.61765 11.9643C0.861728 12.2084 1.25746 12.2084 1.50153 11.9643L6.08175 7.38409L10.662 11.9643C10.906 12.2084 11.3018 12.2084 11.5458 11.9643C11.7899 11.7202 11.7899 11.3245 11.5458 11.0804L6.96563 6.5002L11.5459 1.91997C11.7899 1.67589 11.7899 1.28016 11.5459 1.03609C11.3018 0.792008 10.9061 0.792008 10.662 1.03609L6.08175 5.61632L1.50151 1.03609Z",
    fill: "#AEAEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.a634c971f85b10097cd211edc3aff709.svg";
export { ForwardRef as ReactComponent };